export const RouterPaths = {
  Consumptions: '/consumptions',
  Dormitory: {
    Base: '/dormitory',
    Signup: '/dormitory/signup',
    PaymentMethodCompletion: '/dormitory/paymentMethodCompletion',
  },
  EVInvoices: '/evInvoices',
  FAQ: '/faq',
  GasConsumptions: '/gasConsumptions',
  Home: '/',
  Inquiry: '/inquiry',
  Invoices: '/invoices',
  Login: '/login',
  Maintenance: '/maintenance',
  PasswordMail: '/passwordmail',
  PaymentMethod: '/payment',
  PaymentMethodRequest: '/payment/request', // いずれは /payment で統一
  Receipts: '/receipts',
  RegisterPassword: '/registerpassword',
  ResetPassword: '/resetpassword',
  User: {
    Base: '/user',
    Edit: '/user/edit',
    MoveOut: '/user/moveOut',
  },
} as const
